import React from 'react';
import { WebsiteDesignProps } from './types';
import { Globe, Plane, Container, Truck } from 'lucide-react';
import { Button } from "@/components/ui/button";

const GlobalLogistics: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Global Supply Institute";

    return (
        <div className="bg-slate-50 min-h-screen font-sans text-slate-800">
            <nav className="bg-blue-900 text-white p-4">
                <div className="container mx-auto flex justify-between items-center">
                    <div className="flex items-center gap-2 font-bold text-xl tracking-tight">
                        <Globe className="text-orange-500" /> {schoolName}
                    </div>
                    <div className="flex gap-6 text-sm font-medium text-slate-300">
                        <a href="#" className="hover:text-white">Training</a>
                        <a href="#" className="hover:text-white">Certification</a>
                        <a href="#" className="hover:text-white">Partners</a>
                    </div>
                </div>
            </nav>

            <header className="relative bg-blue-900 text-white h-[600px] flex items-center overflow-hidden">
                <div className="absolute inset-0 z-0 opacity-20">
                     {/* Abstract Map Dots */}
                     <svg width="100%" height="100%">
                         <pattern id="dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                             <circle cx="2" cy="2" r="1" fill="white"/>
                         </pattern>
                         <rect width="100%" height="100%" fill="url(#dots)"/>
                         {/* Connecting Lines */}
                         <path d="M100 100 Q 400 50 600 300 T 1000 100" fill="none" stroke="orange" strokeWidth="2" strokeDasharray="10 10" opacity="0.5"/>
                         <path d="M0 500 Q 300 300 800 500" fill="none" stroke="orange" strokeWidth="2" strokeDasharray="10 10" opacity="0.3"/>
                     </svg>
                </div>
                
                <div className="container mx-auto px-6 relative z-10 grid grid-cols-1 md:grid-cols-2 gap-12">
                    <div>
                        <div className="inline-block px-3 py-1 bg-orange-500 text-white text-xs font-bold uppercase rounded mb-4">
                            Global Standard
                        </div>
                        <h1 className="text-5xl font-bold mb-6 leading-tight">
                            Moving the World <br/> Forward.
                        </h1>
                        <p className="text-lg text-blue-100 mb-8 max-w-lg">
                            Master the complexities of international supply chains, logistics, and transport management.
                        </p>
                        <div className="flex gap-4">
                            <Button className="bg-orange-500 hover:bg-orange-600 text-white font-bold h-12 px-8">
                                Start Training
                            </Button>
                            <Button variant="outline" className="border-white text-white hover:bg-white/10 h-12 px-8 bg-transparent">
                                Corporate Plans
                            </Button>
                        </div>
                    </div>
                    <div className="hidden md:block">
                        <div className="bg-white/10 backdrop-blur-sm p-8 rounded-lg border border-white/20">
                             <div className="flex justify-between items-center mb-6 border-b border-white/20 pb-4">
                                 <span className="font-mono text-sm">Tracking ID: 8829-XJ</span>
                                 <span className="text-green-400 font-bold text-sm">● In Transit</span>
                             </div>
                             <div className="space-y-6">
                                 <div className="flex gap-4 items-center">
                                     <div className="w-8 h-8 rounded-full bg-blue-800 flex items-center justify-center"><Plane size={16}/></div>
                                     <div className="text-sm">
                                         <div className="font-bold">Air Freight</div>
                                         <div className="text-blue-200 text-xs">Module 1: International Regulations</div>
                                     </div>
                                 </div>
                                 <div className="flex gap-4 items-center">
                                     <div className="w-8 h-8 rounded-full bg-blue-800 flex items-center justify-center"><Container size={16}/></div>
                                     <div className="text-sm">
                                         <div className="font-bold">Sea Cargo</div>
                                         <div className="text-blue-200 text-xs">Module 2: Port Operations</div>
                                     </div>
                                 </div>
                                 <div className="flex gap-4 items-center">
                                     <div className="w-8 h-8 rounded-full bg-blue-800 flex items-center justify-center"><Truck size={16}/></div>
                                     <div className="text-sm">
                                         <div className="font-bold">Last Mile</div>
                                         <div className="text-blue-200 text-xs">Module 3: Distribution</div>
                                     </div>
                                 </div>
                             </div>
                        </div>
                    </div>
                </div>
            </header>

            <section className="bg-orange-500 py-4">
                <div className="container mx-auto px-6 flex justify-between items-center text-white font-mono text-sm overflow-hidden">
                    <span className="whitespace-nowrap">NYK /// TYO /// LDN /// SGP /// DXB</span>
                    <span className="hidden md:inline whitespace-nowrap">REAL-TIME DATA STREAMS ACTIVE</span>
                </div>
            </section>
        </div>
    );
};

export default GlobalLogistics;
